/* Use-case pages: search and filter the list of connectable tools (snippets/ow-connectors-wall.liquid). Text only. */
(function () {
  'use strict';
  var w = document.querySelector('[data-uc-wall]');
  if (!w) return;
  var q = w.querySelector('.uc-wall__q'), cats = [].slice.call(w.querySelectorAll('.uc-wall__c')), tiles = [].slice.call(w.querySelectorAll('.uc-wall__t'));
  var empty = w.querySelector('.uc-wall__e'), count = w.querySelector('[data-uc-wall-count]'), cat = '';
  function norm(s) { return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  function run() {
    var t = norm(q && q.value), n = 0;
    tiles.forEach(function (el) {
      var ok = (!cat || el.getAttribute('data-cat') === cat) && (!t || (el.getAttribute('data-k') || '').indexOf(t) > -1);
      el.hidden = !ok; if (ok) n++;
    });
    if (empty) empty.hidden = n > 0;
    if (count) count.textContent = 'Showing ' + n + ' of ' + tiles.length + ' tools';
  }
  if (q) q.addEventListener('input', run);
  cats.forEach(function (b) {
    b.addEventListener('click', function () {
      cat = b.getAttribute('data-cat') || '';
      cats.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      run();
    });
  });
  run();
})();
